import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router";
import { useMe } from "../api/hooks";
import { Spinner, ErrorNote } from "../components/ui";
import { NoAccessPage } from "../pages/NoAccessPage";

/**
 * `admin`: admins only (owners go to /locations). `superAdmin`: super admins only (plain admins go
 * to /admin). `ownerOnly`: the owner app; an admin is sent to the same path under /admin.
 */
export function RequireAuth({ admin, superAdmin, ownerOnly, children }: { admin?: boolean; superAdmin?: boolean; ownerOnly?: boolean; children: ReactNode }) {
  const me = useMe();
  const here = useLocation();
  if (me.isPending) return <div className="p-8"><Spinner label="Signing you in…" /></div>;
  if (me.isError) return <div className="p-8"><ErrorNote error={me.error} /></div>;
  if (!me.data) return <Navigate to="/login" replace state={{ from: here.pathname }} />;
  if (me.data.role === "none") return <NoAccessPage email={me.data.email} />;
  if ((admin || superAdmin) && me.data.role !== "admin") return <Navigate to="/locations" replace />;
  if (superAdmin && !me.data.superAdmin) return <Navigate to="/admin" replace />;
  if (ownerOnly && me.data.role === "admin") return <Navigate to={`/admin${here.pathname}`} replace />;
  return <>{children}</>;
}
